const AUTH_DOMAIN = 'controle.local'

const USERNAME_PATTERN = /^[a-z0-9]+(?:[._-][a-z0-9]+)*$/

export function normalizeUsername(value: string): string {
  return value.trim().toLowerCase()
}

export function usernameToAuthEmail(value: string): string {
  const username = normalizeUsername(value)

  if (!USERNAME_PATTERN.test(username)) {
    throw new Error('Usuário inválido.')
  }

  return `${username}@${AUTH_DOMAIN}`
}

export function authEmailToUsername(email: string): string {
  const normalized = email.trim().toLowerCase()
  const suffix = `@${AUTH_DOMAIN}`

  if (!normalized.endsWith(suffix)) return normalized

  return normalized.slice(0, -suffix.length)
}
